module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-checkbox', _vm._b({
    staticClass: "rt-checkbox"
  }, 'el-checkbox', _vm.$attrs, false), [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c390fb8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/checkbox/rtCheckbox.vue
// module id = 1479
// module chunks = 124